module.exports = __webpack_public_path__ + "static/media/instagram_logo.58fec832.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/instagram_logo.svg
// module id = 1227
// module chunks = 0